(function () {
  'use strict';

  var NOTE_SELECTOR = '[data-cart-note-input]';
  var SAVE_BUTTON_SELECTOR = '[data-cart-note-save]';
  var CHECKOUT_SELECTOR = '[name="checkout"], [href="/checkout"], #checkout, #CartDrawer-Checkout';
  var SAVE_LABEL_DEFAULT = 'Save note';
  var SAVE_LABEL_SAVING = 'Saving...';
  var SAVE_LABEL_SAVED = 'Saved';
  var LEGACY_TEST_NOTE = 'adaawdw';

  var lastSavedNote = null;

  function matchesSelector(element, selector) {
    if (!element || element.nodeType !== 1) {
      return false;
    }

    var proto = Element.prototype;
    var matcher = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
    return matcher ? matcher.call(element, selector) : false;
  }

  function closestSelector(element, selector) {
    var current = element;

    while (current && current.nodeType === 1) {
      if (matchesSelector(current, selector)) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function normalizeNote(value) {
    return (value || '').replace(/\r\n/g, '\n');
  }

  function syncAllNoteInputs(value) {
    var nextValue = value || '';
    var inputs = document.querySelectorAll(NOTE_SELECTOR);

    Array.prototype.forEach.call(inputs, function (input) {
      input.value = nextValue;
    });
  }

  function getPrimaryNoteInput() {
    var noteInputs = document.querySelectorAll(NOTE_SELECTOR);
    if (!noteInputs.length) {
      return null;
    }

    var firstVisible = null;
    Array.prototype.forEach.call(noteInputs, function (input) {
      if (firstVisible) {
        return;
      }

      if (input.offsetParent !== null) {
        firstVisible = input;
      }
    });

    return firstVisible || noteInputs[0];
  }

  function saveCartNote(note, options) {
    var requestOptions = options || {};
    var normalizedNote = normalizeNote(note);

    if (!requestOptions.force && normalizedNote === lastSavedNote) {
      return Promise.resolve();
    }

    lastSavedNote = normalizedNote;

    var fetchOptions = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        note: normalizedNote,
      }),
    };

    if (requestOptions.keepalive) {
      fetchOptions.keepalive = true;
    }

    return fetch('/cart/update.js', fetchOptions).catch(function () {
      // Note save should never block checkout flow.
    });
  }

  function setSaveButtonState(button, state) {
    if (!button) {
      return;
    }

    if (!button.dataset.defaultLabel) {
      button.dataset.defaultLabel = (button.textContent || '').trim() || SAVE_LABEL_DEFAULT;
    }

    if (state === 'saving') {
      button.textContent = SAVE_LABEL_SAVING;
      button.classList.add('is-saving');
      button.setAttribute('aria-busy', 'true');
      return;
    }

    if (state === 'saved') {
      button.textContent = SAVE_LABEL_SAVED;
      button.classList.remove('is-saving');
      button.removeAttribute('aria-busy');
      return;
    }

    button.textContent = button.dataset.defaultLabel;
    button.classList.remove('is-saving');
    button.removeAttribute('aria-busy');
  }

  function saveFromInput(input, options) {
    if (!input) {
      return Promise.resolve();
    }

    return saveCartNote(input.value, options || { force: true });
  }

  function saveFromButton(button) {
    var scope = button.closest('cart-note') || button.parentElement;
    var scopedInput = scope ? scope.querySelector(NOTE_SELECTOR) : null;
    var input = scopedInput || getPrimaryNoteInput();

    if (!input) {
      return Promise.resolve();
    }

    setSaveButtonState(button, 'saving');

    return saveFromInput(input, { force: true }).then(function () {
      setSaveButtonState(button, 'saved');
      window.setTimeout(function () {
        setSaveButtonState(button, 'default');
      }, 1200);
    });
  }

  function clearLegacyTestNote() {
    var input = getPrimaryNoteInput();
    if (!input) {
      return;
    }

    if (normalizeNote(input.value).trim().toLowerCase() !== LEGACY_TEST_NOTE) {
      return;
    }

    syncAllNoteInputs('');
    saveCartNote('', { force: true });
    lastSavedNote = '';
  }

  document.addEventListener(
    'click',
    function (event) {
      var saveButton = closestSelector(event.target, SAVE_BUTTON_SELECTOR);

      if (saveButton) {
        event.preventDefault();
        saveFromButton(saveButton);
        return;
      }

      var checkoutTarget = closestSelector(event.target, CHECKOUT_SELECTOR);

      if (!checkoutTarget) {
        return;
      }

      saveFromInput(getPrimaryNoteInput(), {
        force: true,
        keepalive: true,
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!form || form.nodeName !== 'FORM') {
        return;
      }

      if (!matchesSelector(form, 'form[action="/cart"], #cart, #CartDrawer-Form')) {
        return;
      }

      var scopedInput = form.querySelector(NOTE_SELECTOR);
      saveFromInput(scopedInput || getPrimaryNoteInput(), {
        force: true,
        keepalive: true,
      });
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!matchesSelector(event.target, NOTE_SELECTOR)) {
      return;
    }

    saveFromInput(event.target, { force: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      var input = getPrimaryNoteInput();
      lastSavedNote = input ? normalizeNote(input.value) : null;
      clearLegacyTestNote();
    });
  } else {
    var initialInput = getPrimaryNoteInput();
    lastSavedNote = initialInput ? normalizeNote(initialInput.value) : null;
    clearLegacyTestNote();
  }
})();
